/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useMemo } from 'react';
import { useUser } from './account';
import { isProfileComplete } from '../utils/signUpFormUtils';

export type UseIsProfileCompleteResult = {
  /** True when every  sign-up form field is filled. */
  isProfileComplete: boolean;
  user: ReturnType<typeof useUser>['data'];
};

/**
 * Whether the current user's sign-up profile is fully complete.
 * Form continue already requires all fields; this is the same boolean for routing.
 */
export const useIsProfileComplete = (
  caller: string = 'useIsProfileComplete',
): UseIsProfileCompleteResult => {
  const userQuery = useUser(caller);

  const complete = useMemo(
    () => isProfileComplete(userQuery.data),
    [userQuery.data],
  );

  return {
    isProfileComplete: complete,
    user: userQuery.data,
  };
};
